module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2e"
  }, [_c('a', {
    attrs: {
      "id": "ch02"
    }
  }), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('span', {
    staticClass: "chnum"
  }, [_vm._v("chapter two")])])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('h2', {
    staticClass: "h2f"
  }, [_vm._v("THE LIGHTEST "), _c('span', {
    staticClass: "small"
  }, [_vm._v("OF")]), _vm._v(" LIGHT")])]), _c('p', {
    staticClass: "author1"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('a', {
    attrs: {
      "id": "chapsec1lev1"
    }
  }, [_c('strong', [_vm._v("Pale Lagers")])])]), _c('a', {
    attrs: {
      "id": "chapsec1lev1"
    }
  }), _c('div', {
    staticClass: "wrapr"
  }, [_c('a', {
    attrs: {
      "id": "chapsec1lev1"
    }
  }), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('div', {
    staticClass: "imgblock W98"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0016-01.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "intro1"
  }, [_vm._v("It might come as a surprise to learn that pale-colored lagers are a relatively recent invention, considering their popularity and abundance. If you were to draw out the entire timeline of beer styles, pale-colored beer would fall toward the modern-day end of the spectrum. Light lagers brewed with adjuncts, like rice and corn, are even more contemporary.")]), _vm._v(" "), _c('p', {
    staticClass: "introi"
  }, [_vm._v("Many factors came together for the creation of the pale lager family, but three scientific advances were absolutely crucial: the discovery of yeast, innovations in kilning, and the invention of refrigeration.")])]), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Discovery of Yeast")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("When humans accidentally discovered the awesomeness of fermentation thousands of years ago, no one knew exactly how or why it happened. They just knew that eating and drinking fermented things made them feel good, and they wanted more.")])])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("It wasn’t until the 1800s that brewers would learn that single-celled organisms were actually the ones responsible for turning the sugary, grain-based liquid called "), _c('em', [_vm._v("wort")]), _vm._v(" into beer. French chemist Louis Pasteur was responsible for identifying these beautiful little booze-excreting creatures we now know to be yeast.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At first, scientists only knew about the yeast strain called "), _c('em', [_vm._v("Saccharomyces cerevisiae")]), _vm._v(", the same yeast used in bread making and the primary strain for the fermentation of ales (but not lagers). Eventually, scientists discovered that all sorts of yeasts and bacteria could be used in fermentation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The first person to isolate a cell of lager yeast was Danish mycologist (aka fungi expert) and fermentation physiologist Emil Christian Hansen. Ultimately, this yeast would be called "), _c('em', [_vm._v("Saccharomyces pastorianus")]), _vm._v(", a tribute to the yeast legend himself, Louis Pasteur.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The isolation of the lager yeast strain was a pinnacle moment for lager brewers. They could finally learn how to control the unknown factor and perfect lager fermentation down to a T.")])]), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('h3', {
    staticClass: "h3"
  }, [_vm._v("Innovations in Kilning")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Did you know that until the late 1600s most beer was brownish or black in color? That’s because most styles of beer are brewed with malted barley, which must be kilned after drying and germinating (the malting process will be discussed more in depth on ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/ch10#page_106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 106")]), _vm._v("). Before the 1600s, most beer was kilned over wood fires. This produced smoky malts that were fairly dark in color, not ideal for brewing pale beers.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eventually, the Brits discovered that kilning over coke could successfully produce pale malts. (Coke is coal heated in the absence of oxygen that gives off heat with little to no smoke.) The lager brewers ultimately picked up on the pale malt trend in the 1800s, hence the birth of the pale lager.")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_vm._v("Invention of Refrigeration")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It is important to note that lager yeast in particular requires cooler temperatures for fermentation. The invention of refrigeration allowed the Germans to brew a more consistent product year round and made it possible to keep beer cold prior to serving. Refrigeration also played a role in keeping beer stabilized, helping it better survive exportation.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The first large-scale refrigerated lagering tanks were developed for the Spaten Brewery in 1870. This allowed lagers to be produced on a larger scale, completely revolutionizing the lager beer industry. The invention of refrigeration is often referenced as a major turning point in the history of beer. It is a key mark of modern-era brewing.")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_c('em', [_vm._v("Reinheitsgebot")]), _vm._v(" and Prohibition")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The "), _c('em', [_vm._v("Reinheitsgebot")]), _vm._v(" (“rye-n-heights-ge-bot”) is the ever-famous German Purity Law. It states that beer must only be brewed with water, hops, and barley (yeast was grandfathered into this list once it was discovered). Although this law is no longer enforced, most German brewers still uphold its rigorous standards. Increased enforcement of the "), _c('em', [_vm._v("Reinheitsgebot")]), _vm._v(" in 1871 forced the extinction of many “impure” beer styles and brewing traditions in Germany. As a result, pilsners and pale lagers became king, dominating the German marketplace from there on out.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("Then things were mostly quiet—until that fateful year, 1920. Although advances in science have been extremely important for the evolution of beer, no single discovery or invention has had as huge of an impact on the history of beer as Prohibition in the United States.")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I’m assuming that everyone reading this book has heard of Prohibition. (If not, then I seriously question the credentials of your American history teachers.) Prohibition essentially started with the ratification of the Eighteenth Amendment in 1920 and lasted until 1933. For thirteen years, ten months, nineteen days, seventeen hours, thirty-two minutes, and thirty seconds the manufacturing and sale of alcoholic beverages was illegal in the United States of America.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Prohibition single-handedly destroyed the craft and artisanal booze industry in the United States. Before Prohibition, there was something like three thousand breweries in the country, but only a couple dozen survived Prohibition, and most of those breweries consolidated to form larger breweries. This set the stage for mass production of domestic beers (in this case, lagers) and the market dominance of said beers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is important to note that before Prohibition even started, imported lagers, especially pilsners, were all the rage. The largest flow of German immigration occurred between 1820 and World War I. The immigrants brought a taste for German-style beers with them, as well as the knowledge and skills for brewing lagers. By the time Prohibition hit, lager sales were outpacing those of ales. And then there was World War II.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("World War II also sucked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Before the American beer industry had a chance to recover from Prohibition, World War II hit the nation. War has been known to breed innovation out of necessity. Important supplies and raw materials are often rationed, forcing industries dependent on those resources to seek out comparable alternatives. In times of war, food is often the resource that is rationed the most.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("During World War II, barley was rationed for beef farmers and most brewers were forced to brew with other “cereal” grains. Although brewers had already been experimenting with supplemental starches like corn before Prohibition, it wasn’t until World War II that it became a common practice. And thus began the mass production of light adjunct-based domestic lagers, yet another reason to hate Hitler.")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_vm._v("The Craft Lager Revolution")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Despite the fact that the overwhelming majority of beer consumed in the world today is mass-produced, adjunct-riddled pale lagers that bear little to no semblance to the traditional pilsners that inspired them, there has been a recent resurgence of craft lagers and pilsners. Some writers have referred to this phenomenon as the “third wave of lagers,” but I prefer to think of it as a part of the overall craft beer revolution.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As with most traditional styles, American brewers like to tweak and manipulate pale lagers by, what I refer to as, “Americanizing” them. Some brew with American hops instead of the traditional Saaz or noble hops, some like to push the alcohol boundaries by brewing imperial versions of pale lagers, some push the bitterness boundaries by using more hops, and some even add weird, nontraditional ingredients into the mix. Examples of Americanized pale lagers include Firestone Walker Pivo Pils (an extra-hoppy pilsner), Dogfish Head Piercing Pils (pilsner brewed with white pear tea and pear juice), and Ballast Point Fathom (an imperial pale lager, aka a super-hoppy imperial lager).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Keep in mind, not all modern-day brewers step outside the box on styles. Some brewers are purists who choose not to adulterate or change traditional recipes. They prefer to brew to style and uphold certain brewing traditions. These brewers should be commended for their work. In an ever-growing world of extreme and weird beers, simple is refreshing.")])]), _c('h3', {
    staticClass: "h3a"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('a', {
    attrs: {
      "id": "chapsec1lev2"
    }
  }), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('strong', [_vm._v("BOHEMIAN (CZECH) PILSENER")])])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("The original pale lager: light yellow, lots of bubbles, notes of sweet hay and tree bark spice. Refreshing.")])]), _vm._v(" "), _c('h4', {
    staticClass: "h4a"
  }, [_c('strong', [_vm._v("BJCP Stats")])]), _vm._v(" "), _c('p', {
    staticClass: "stats"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("SRM:")]), _vm._v(" 3.5–6")]), _vm._v(" "), _c('p', {
    staticClass: "stats"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("IBU:")]), _vm._v(" 35–45")]), _vm._v(" "), _c('p', {
    staticClass: "stats"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("ABV:")]), _vm._v(" 4.2–5.4 percent")]), _vm._v(" "), _c('p', {
    staticClass: "stats"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("OG:")]), _vm._v(" 1.044–1.056")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("My two cents:")]), _vm._v(" The pilsner is quite possibly the most successful and popular beer style in the world. The majority of beer brewed and consumed in the world is either a pilsner or a derivative of it (aka adjunct lager).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Brilliant pale gold with a large white head and medium body, it’s easy to see why the style quickly took over once brewers could make it. The classic Bohemian pilsener is fizzy and refreshing but also filled with subtle complexity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In fact, it’s one of the best styles for observing water’s impact on the overall flavor of beer. It’s technically the hoppiest of the pale lagers, but the perceived bitterness varies notably with water.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Soft water, in this particular case, tends to take the edge off the bitterness in hops. As a result, the Bohemian pilsener has a slightly lower level of perceived hoppiness than its hard water–brewed German counterpart (discussed next).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The other important ingredient in this style is Saaz hops, a varietal commonly described as earthy and spicy. I equate Saaz hops to being something like cocktail bitters. It adds a subtle bitter and wood-like herbal quality that you would notice more in its absence than in its presence.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("In the glass:")]), _vm._v(" Light yellow with lots of bubbles")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("In the nose:")]), _vm._v(" Unsalted crackers, fresh hay and grass")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("In the mouth:")]), _vm._v(" Sweet hay, biscuits with a drop of honey, dash of Angostura bitters")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("In one word:")]), _vm._v(" Refreshing")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Pour it into this:")]), _vm._v(" Pilsner glass (tall, thin, and tapered)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Drink instead of:")]), _vm._v(" Vodka soda and white zinfandel (BTW, if you drink white zin, put down this book and reevaluate your life. And don’t get me started on vodka.)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Pair with:")]), _vm._v(" Pilseners of all types are a great match for fried foods but can also work nicely with grilled foods, salads, and even sushi. When it comes to cheese, think American varieties—mild cheddar, havarti, colby jack, and cream cheese all work well with pale lagers. Or go super traditional with Czech foods such as potato dumplings filled with smoked meat, bramboráky (fried potato pancakes spiced with marjoram, salt, pepper, and garlic), beer cheese (soft cheese mixed with raw onions and mustard), and goulash.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Brief history lesson:")]), _vm._v(" The Bohemian pilsener was the first pale-colored lager. Josef Groll developed the original recipe at Pilsner Urquell, a collective brewery at the time, using Bavarian yeast that had been smuggled into Bohemia by a local monk (those robes can hide just about everything).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In lieu of using the heavily kilned malts his stubborn colleagues in Germany were using, Groll found inspiration in relatively new, but not really that new, pale malt coming from England. As legend has it, Pilsner Urquell was the first brilliant beer to ever see the light of day. (In the beer world, brilliant refers to pristine clarity.)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Try it:")]), _vm._v(" Pilsner Urquell, Gordon Biersch Czech Style Pilsner, Lagunitas Pils, Samuel Adams Noble Pils, Oskar Blues Mama’s Little Yella Pils")])]), _c('p', {
    staticClass: "shead"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('strong', [_vm._v("Beer Hates Ultraviolet Light")])])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "imgblock W98"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0021-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Hops hate UV light. When hops come into contact with UV light, a chemical reaction occurs that causes the beer to smell as if a skunk had sprayed it. Hence, light-struck beers are commonly referred to as “skunked.” Beers packaged in green bottles are extremely susceptible to light. A lot of imported lagers come in green glass bottles and, more often than not, are skunked by the time they reach your glass. That’s because green glass bottles, unlike brown bottles, offer little to no protection from UV light.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Heineken now purposefully exposes its wort to light during the brewing process, forcing it to become skunked prior to bottling. Yep, you read that right. Because most of its beer was already skunked during exportation, US-based Heineken consumers became accustomed to its “unique” skunk flavor—so much so that light-struck flavor became an attribute of the beer, rather than a flaw. If you really want to know what light-struck tastes like, grab a Heineken.")]), _vm._v(" "), _c('p', {
    staticClass: "imagesb"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/scommon1.gif",
      "width": "70%"
    }
  })])]), _c('h3', {
    staticClass: "h3a"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('a', {
    attrs: {
      "id": "chapsec1lev3"
    }
  }), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('strong', [_vm._v("MUNICH HELLES")])])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Pronounced hell-us, it’s the first German knock-off of Bohemian pilsener. Brilliant yellow, super grassy, hints of honey and lemon peel. Crisp.")])]), _vm._v(" "), _c('h4', {
    staticClass: "h4a"
  }, [_c('strong', [_vm._v("BJCP Stats")])]), _vm._v(" "), _c('p', {
    staticClass: "stats"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("SRM:")]), _vm._v(" 3–5")]), _vm._v(" "), _c('p', {
    staticClass: "stats"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("IBU:")]), _vm._v(" 16–22")]), _vm._v(" "), _c('p', {
    staticClass: "stats"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("ABV:")]), _vm._v(" 4.7–5.4 percent")]), _vm._v(" "), _c('p', {
    staticClass: "stats"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("OG:")]), _vm._v(" 1.045–1.051")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("My two")]), _vm._v(" "), _c('span', {
    staticClass: "ash"
  }, [_vm._v("cents:")]), _vm._v(" Have you ever heard the saying, “not your Dad’s beer?” Well, the helles is “your Dad’s beer”—at least it was my dad’s beer. I didn’t really understand his preoccupation with the style, especially the one produced by Spaten. To me, it seemed flavorless, lackluster, and dull, barely a step up from the domestic lagers everyone else drank. It took me a really long time to embrace its simplicity and, ultimately, enjoy its flavor. When I finally did, I fell in love with the helles.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Of all the pale lager styles, the helles is typically the sweetest. But it’s not sugary sweet; it’s chewing-on-fresh-grass sweet. It is also the least bitter of the pale lagers, hence seeming sweeter than the others; but it’s not overly sweet. The ability to brew a perfect helles, or a pilsner for that matter, is a true testament of the talent and skill of the brewer. Its ingredients might seem simple, but it requires a delicate touch that most extreme brewers have a hard time mastering. Because the style is so soft and clean, any and all flaws extracted during the brewing process are extremely evident in the final product. A helles should never taste fruity or have any hint of dank or citrusy American hops.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("In the glass:")]), _vm._v(" Bright straw yellow, lots of little bubbles, fluffy head")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("In the nose:")]), _vm._v(" Fresh cut grass, sweet hay, honey, and slightly stale bread")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("In the mouth:")]), _vm._v(" Sweet hay, sweet grass, lemon peel")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("In one word:")]), _vm._v(" Flawless")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Pour it into this:")]), _vm._v(" Pilsner glass")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Drink instead of:")]), _vm._v(" A cosmopolitan or pinot grigio")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Pair with:")]), _vm._v(" Weisswurst (traditional Bavarian sausage made from finely minced veal and fresh back bacon), pretzels (soft and hard), vinaigrette-based salad dressings, Chinese food, grilled chicken, lighter seafood, and soft mild cheeses like mozzarella, goat, and muenster")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Brief history lesson:")]), _vm._v(" In German, the term "), _c('em', [_vm._v("hell")]), _vm._v(" is an adjective meaning light or bright. The Munich helles was the first pale lager brewed in Munich. It was created by Spaten Brewery to compete with the Bohemian pilsener, which was becoming so popular it was scary.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What most differentiates the helles from the pilsners is its significantly lower level of hop bitterness. Germans historically have had lower tolerance levels for hop bitterness, and the beers they brew are a reflection of this.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Outside of Germany, the style is often labeled “Munich Original Lager,” probably because most consumers know the word "), _c('em', [_vm._v("lager")]), _vm._v(", but not the term "), _c('em', [_vm._v("helles")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Try it:")]), _vm._v(" Spaten Premium Lager (the classic), Paulaner Premium Lager, Stoudt’s Gold Lager, Maui Brewing Co. Bikini Blonde Lager, Ballast Point Longfin Lager")])]), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('div', {
    staticClass: "wrap"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('div', {
    staticClass: "imgblock W98"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0022-01.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v("Munich Helles")])])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('h3', {
    staticClass: "h3a"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('a', {
    attrs: {
      "id": "chapsec1lev4"
    }
  }), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('strong', [_vm._v("GERMAN PILSNER")])])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Straw-colored, highly carbonated, clean and crisp with notes of fresh grass, dried flowers, and bitter herbs.")])]), _vm._v(" "), _c('h4', {
    staticClass: "h4a"
  }, [_c('strong', [_vm._v("BJCP Stats")])]), _vm._v(" "), _c('p', {
    staticClass: "stats"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("SRM:")]), _vm._v(" 2–5")]), _vm._v(" "), _c('p', {
    staticClass: "stats"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("IBU:")]), _vm._v(" 25–45")]), _vm._v(" "), _c('p', {
    staticClass: "stats"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("ABV:")]), _vm._v(" 4.4–5.2 percent")]), _vm._v(" "), _c('p', {
    staticClass: "stats"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("OG:")]), _vm._v(" 1.044–1.050")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("My two cents:")]), _vm._v(" This is by far my favorite of the pale lagers. It’s interesting how two seemingly similar beer styles—the Bohemian pilsener and the German pilsner—can have such subtle, yet defining differences. It’s not the hops, malt, or even the yeast. It’s all in the water. The Bohemian pilsener is brewed with soft water, while the German version is brewed with hard water.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Beers brewed with hard water tend to be drier than those brewed with soft water. And because there is less residual malt sweetness in the beer, the hop bitterness comes through stronger. The moral of the story: German pilsners are hoppier than the Bohemian versions, making them the hoppiest of all the traditional pale lager styles. (I say traditional because American versions with American hops can be way hoppier.)")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Like the pilsener, much else is the same. The beer is straw-colored with just a little malt sweetness. It’s clean, and the hop aroma is distinctively German: spicy or flowery rather than citrusy or fruity.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("In the glass:")]), _vm._v(" Brilliant light gold, super bubbly, large white head")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("In the nose:")]), _vm._v(" Fresh hay, dried flowers, and graham crackers")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("In the mouth:")]), _vm._v(" Zesty citrus, fresh grass, bitter herbs, and water crackers")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("In one word:")]), _vm._v(" Crisp")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Pour it into this:")]), _vm._v(" Pilsner glass")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Drink instead of:")]), _vm._v(" Adjunct lagers, vodka gimlet, or sauvignon blanc")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Pair with:")]), _vm._v(" Spicy cuisines such as Thai, Indian, and Mexican; shellfish; pork products such as sausage, ham, and bacon; grilled fish and veggies; fried things; pizza; and mildly sharp and pungent cheeses like cheddar, Humboldt Fog, and muenster")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Brief history lesson:")]), _vm._v(" The first German brewery to attempt a pilsner-style beer was Aktienbrauerei Zum Bierkeller of Radeberg, which is now known as Radeberger Brewery. As opposed to the helles, the German Pilsner was created as a direct replica of the Bohemian pilsener but used German ingredients and higher-sulfate water.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Interesting fact:")]), _vm._v(" The French love the German Pils. In fact, when it was first created, France was the largest export market for this style.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Try it:")]), _vm._v(" Radeberger Pilsner (the original), Jever Pilsener, Trumer Pils, Spaten Pils, König Pilsener, Pinkus Organic Ur Pils, Harpoon Bohemian Pilsner")])]), _c('h3', {
    staticClass: "h3a"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('a', {
    attrs: {
      "id": "chapsec1lev5"
    }
  }), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('strong', [_vm._v("DORTMUNDER EXPORT")])])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Golden yellow, super balanced, good carbonation; the booziest of the pale lagers.")])]), _vm._v(" "), _c('h4', {
    staticClass: "h4a"
  }, [_c('strong', [_vm._v("BJCP Stats")])]), _vm._v(" "), _c('p', {
    staticClass: "stats"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("SRM:")]), _vm._v(" 4–6")]), _vm._v(" "), _c('p', {
    staticClass: "stats"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("IBU:")]), _vm._v(" 23–30")]), _vm._v(" "), _c('p', {
    staticClass: "stats"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("ABV:")]), _vm._v(" 4.8–6.0 percent")]), _vm._v(" "), _c('p', {
    staticClass: "stats"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("OG:")]), _vm._v(" 1.048–1.056")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("My two cents:")]), _vm._v(" The Dortmunder Export is the baby bear of the pale lagers. Not as sweet as the helles (mama bear) but not as bitter as the pilsner (papa bear), for some it’s juuuusst right. Its defining characteristic is probably its alcohol content, which is higher than all the other pale lagers. It is also the darkest in color and the richest of lagers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Honestly, this style is hard to come by. That’s mostly because it lacks the reputation and popularity of the other pale lager styles. If you can find a Dortmunder-style lager from a brewery that has actually done the style justice, it will be well worth every penny.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Just like its brethren, it’s a brilliantly clear beer with a fluffy white head. However, since the malt character is ramped up, you’ll often notice the color is more of a true golden than the lighter beers. It also may have a light touch of dimethyl sulfide (DMS), which is to say it may have a touch of a creamed-corn note in its aroma, but there will be no yeasty esters.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("In the glass:")]), _vm._v(" Deep yellow, clear with lots of little bubbles, big white head")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("In the")]), _vm._v(" "), _c('span', {
    staticClass: "ash"
  }, [_vm._v("nose:")]), _vm._v(" Toasted bread and fresh cut grass")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("In the mouth:")]), _vm._v(" Bready, floral, and grassy")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("In one word:")]), _vm._v(" Smooth")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Pour it into this:")]), _vm._v(" Pilsner glass")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Drink instead of:")]), _vm._v(" Vodka tonic or chenin blanc")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Pair with:")]), _vm._v(" Hearty traditional German foods such as sauerbraten, spätzle, and bratwurst; comfort foods like stews, chicken pot pie, and mashed potatoes; and mild soft cheeses like havarti, gouda (especially smoked), and colby jack")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Brief history")]), _vm._v(" "), _c('span', {
    staticClass: "ash"
  }, [_vm._v("lesson:")]), _vm._v(" The lesser known of the light-colored lagers, the Dortmunder Export is another pilsner-inspired style from Germany. It originates from the industrial town of Dortmund. This version was brewed with slightly more alcohol to make it more ideal for export.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Interesting fact:")]), _vm._v(" The Dortmunder Export wasn’t always a recognized style. In 1969, Fred Eckhardt wrote in his published handbook “A Treatise on Lager Beers” that the Dortmunder Export is a distinctive enough pale lager to be classed as a separate beer style. And thus it was.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Try it:")]), _vm._v(" Dortmunder Union Export, Great Lakes Dortmunder Gold, Thirsty Dog Labrador Lager, Ninkasi Oktoberfest Dortmund-Style Lager, 3 Floyds Jinx Proof")])]), _c('p', {
    staticClass: "shead"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('strong', [_vm._v("The Weird Weissbier (aka Hefeweizen)")])])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Although Americans are more familiar with the term Hefeweizen, the Germans refer to the style as the Weissbier or Weizenbier. And it is one odd style of beer to come out of Germany. It’s predominantly brewed with wheat and it’s fermented with ale yeast at relatively high temperatures. And why is that weird, you ask? Because Germany is the country known for creating a law (the "), _c('em', [_vm._v("Reinheitsgebot")]), _vm._v(") against brewing with adjuncts like wheat. And as you’ve seen on the last few pages, it’s also the country responsible for perfecting the lager. So even though the Hefe might seem like something that came out of Belgium, we’ll go ahead and take a look at it here alongside its fellow Germans.")])]), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('h3', {
    staticClass: "h3as"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('a', {
    attrs: {
      "id": "chapsec1lev6"
    }
  }, [_c('strong', [_vm._v("HEFEWEIZEN/WEISSBIER")])])]), _c('a', {
    attrs: {
      "id": "chapsec1lev6"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Hazy pale yellow, bubble gum, orange peel, banana bread, spicy, very effervescent, and dry.")])])])]), _c('a', {
    attrs: {
      "id": "chapsec1lev6"
    }
  }, [_c('h4', {
    staticClass: "h4a"
  }, [_c('strong', [_vm._v("BJCP Stats")])]), _vm._v(" "), _c('p', {
    staticClass: "stats"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("SRM:")]), _vm._v(" 2–8")]), _vm._v(" "), _c('p', {
    staticClass: "stats"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("IBU:")]), _vm._v(" 8–15")]), _vm._v(" "), _c('p', {
    staticClass: "stats"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("ABV:")]), _vm._v(" 4.3–5.6 percent")]), _vm._v(" "), _c('p', {
    staticClass: "stats"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("OG:")]), _vm._v(" 1.044–1.052")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("My two cents:")]), _vm._v(" Super yeasty and loaded with lots of fruity esters (mainly banana and bubblegum) and phenolics, Hefeweizens are very closely related in flavor and aroma to Belgian ales yet are still very much German in nature. By that, I mean that the style is more regulated than wheat beers brewed elsewhere.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("According to German law, beers that bear the name Weissbier (or equivalent) must be brewed with at least 50 percent malted wheat, but most are actually made with 60 to 70 percent malted wheat. The rest is, of course, malted barley.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Many people classify the Hefeweizen as a chick beer (you know, a style consumed mostly by women). I’m not sure when and where this stereotype came to be, but something tells me it has to do with the inappropriate fruit garnish that often accompanies this style. Please pardon my rant, but these are two issues that we need to address.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "chapsec1lev6"
    }
  }, [_vm._v("First, taste has no gender and, therefore, no style of beer is more favorable to one sex over the other. Second, fruit garnishes are almost always inappropriate when it comes to serving beer. I say almost always because there are a few brewers out there like Shaun O’Sullivan of 21st Amendment who encourage fruit garnishments (in his case, a wedge ")]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("of watermelon on the High or Hell Watermelon Wheat beer). However, unless the brewer intends for there to be a fruit garnish, it is absolutely inappropriate. And trust me, I’m not the first (or last) person in the craft beer industry to rant about either of these subjects. But, moving on …")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("In the glass:")]), _vm._v(" super cloudy, straw yellow, large fluffy white head")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("In the nose:")]), _vm._v(" banana, bubble gum, clove, and orange peel")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("In the mouth:")]), _vm._v(" banana bread, vanilla, lemon bars")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("In one word:")]), _vm._v(" Fluffy")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Pour it in this:")]), _vm._v(" Weizen glass")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Drink instead of:")]), _vm._v(" Sangria, piña colada")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Pair with:")]), _vm._v(" Highly carbonated with soft flavors and little to no bitterness, Hefeweizens are a good match for lighter fare—like fresh seafood, chicken, salads, and fruit desserts—and of course, German cuisine. I like pairing Hefeweizens with beet salads, goat cheese, cocktail shrimp, crab cakes, pretzels with mustard, sausages, lemon gelato, strawberry shortcake, or bananas foster.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Brief history lesson:")]), _vm._v(" The Weissbier actually has a pretty interesting story. Scientists have been able to date the brewing of wheat beers back to the Bronze Age—which started around 3300 BC. This really isn’t too much of a surprise, considering most ancient “beer” was brewed with a smorgasbord of grains. Light wheat beers, however, didn’t come “to be” until advances in kilning made pale malts accessible. But, before the Weissbier would come into existence, it would have to clear one great big hurdle—the "), _c('em', [_vm._v("Reinheitsgebot")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Long story short, the "), _c('em', [_vm._v("Reinheitsgebot")]), _vm._v(" attempted to end all wheat beer brewing in Germany (Bavaria at the time), but a few medieval Dukes in Bavaria were able to obtain exclusive brewing rights (not without a price, though) to maintain the production of wheat beers. It eventually became a huge source of revenue for Bavaria, which was pretty much a war state at this point.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The popularity of the Weissbier saw a huge fall in the late 1700s, but was revived in 1856 when the Schneider Family bought the legal rights to brew the style. As with all styles, Prohibition took a hit on the Weissbier, but it regained strength again in the 1960s and has been a very popular style since.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Try it:")]), _vm._v(" Weihenstephaner Hefeweissbier, Schneider Weisse Weizenhell, Paulaner Hefeweizen, Sierra Nevada Kellerweis, Two Brothers Ebel’s Weiss Beer, Widmer Hefeweizen.")]), _vm._v(" "), _c('p', {
    staticClass: "imagesb"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/scommon1.gif",
      "width": "70%"
    }
  })])]), _c('h3', {
    staticClass: "h3a"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('a', {
    attrs: {
      "id": "chapsec1lev7"
    }
  }), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('strong', [_vm._v("CLASSIC (PREMIUM) AMERICAN PILSNER")])])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Fizzy yellow beer brewed with adjuncts such as corn and rice; pale, lackluster yet consistent.")])]), _vm._v(" "), _c('h4', {
    staticClass: "h4a"
  }, [_c('strong', [_vm._v("BJCP Stats")])]), _vm._v(" "), _c('p', {
    staticClass: "stats"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("SRM:")]), _vm._v(" 3–6")]), _vm._v(" "), _c('p', {
    staticClass: "stats"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("IBU:")]), _vm._v(" 25–40")]), _vm._v(" "), _c('p', {
    staticClass: "stats"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("ABV:")]), _vm._v(" 4.5–6 percent")]), _vm._v(" "), _c('p', {
    staticClass: "stats"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("OG:")]), _vm._v(" 1.044–1.060")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("My two")]), _vm._v(" "), _c('span', {
    staticClass: "ash"
  }, [_vm._v("cents:")]), _vm._v(" Oh, you seriously thought I was going to talk about the yellow fizzy corn beers in my book? Ha! If you’ve never tasted a macro lager, I commend, if not envy, you. We’ve all been down this road, whether it be in high school (shhhh) or college. These beers, when made by the two or three large breweries famous for them, are typically similar to their German counterparts in appearance, but their aroma and taste is noticeably different. They’re often made with 20 to 30 percent flaked maize or rice in combination with six-row barley. They have a grainy, corn flavor if you really try to taste them. There is hop bitterness, but never hop aroma. In general, they are not much more than fizzy beer-like water, and they are best served ice cold.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("In the glass:")]), _vm._v(" Yellow and fizzy")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("In the nose:")]), _vm._v(" Stale Cheerios with hints of grass that may or may not have been peed on")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("In the mouth:")]), _vm._v(" Biodegradable corn cups")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("In one word:")]), _vm._v(" Fizzy")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Pour it into this:")]), _vm._v(" Pint glass or from the can")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Drink instead of:")]), _vm._v(" Water")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Pair with:")]), _vm._v(" Hot dogs, beefy jerky, boxed mac and cheese, frozen pizza, and pretty much anything you would find in a ballpark or football stadium")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Brief history lesson:")]), _vm._v(" As previously noted, the classic American lager was a pilsner-inspired style brewed in the United States. Pre-Prohibition, the style was a bit hoppier and less adjunct-riddled. Post-Prohibition, the IBUs dropped, alcohol dropped, and adjuncts became a definitive characteristic of the style.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Try it:")]), _vm._v(" Coors Banquet, Pabst Blue Ribbon, Budweiser something—why are you doing this to yourself? Seriously, why?")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Feeling adventurous?")]), _vm._v(" Try a Radler—the German version of the Shandy. The drink is essentially a concoction made of various types of German beers, usually a light lager, mixed with lemonade or soda. It’s very popular in the summer months and for good reason. See ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/ch15#page_228",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 228")]), _vm._v(" for my recipe.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Note:")]), _vm._v(" Many American craft brewers have put their own twist on traditional pale lagers. These lagers don’t typically fall under the “classic American lager” category because most are brewed with traditional ingredients, not adjuncts. Some stick to traditional recipes, some use adjuncts like corn and rice, some have Americanized them with American-grown hops, and some have even gone as far as to imperialize them (brew them at double, sometimes triple strength). And now, there is even a style known as the India pale lager (IPL) rapidly emerging. Those crazy Americans.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I say skip the mass-produced, get crazy, and try one of these nonconventional Americanized pale lagers: Dogfish Head My Antonia, Base Camp In-Tents IPL, Flying Dog UnderDog Atlantic Lager, Jack’s Abby Hoponius Union, or Odell Double Pilsner.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3a"
  }, [_c('a', {
    attrs: {
      "id": "chapsec1lev8"
    }
  }), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('strong', [_vm._v("KÖLSCH")])])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Brilliant pale gold, thin head, soft hay and grass aromas, faint hints of fruit (typically apple), super crisp, refreshing.")])]), _vm._v(" "), _c('h4', {
    staticClass: "h4a"
  }, [_c('strong', [_vm._v("BJCP Stats")])]), _vm._v(" "), _c('p', {
    staticClass: "stats"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("SRM:")]), _vm._v(" 3–6")]), _vm._v(" "), _c('p', {
    staticClass: "stats"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("IBU:")]), _vm._v(" 25–40")]), _vm._v(" "), _c('p', {
    staticClass: "stats"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("ABV:")]), _vm._v(" 4.5–6 percent")]), _vm._v(" "), _c('p', {
    staticClass: "stats"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("OG:")]), _vm._v(" 1.044–1.060")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("My two cents:")]), _vm._v(" When it comes to the specs (aka color, bitterness, alcohol etc.)—the Kölsch and the German Pilsner are nearly identical. Both are (typically) brewed with pilsner or pale malt and noble hops. The fundamental difference is yeast. Technically speaking, the Kölsch is a German pale ale (despite its remarkable semblance to a pale lager). A Kölsch is fermented with ale yeast—but done so at cooler temperatures and then lagered for a month. It’s considered a hybrid rather than a pure lager or ale.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("However, I consider it more of a lager and here’s why: I often joke that anyone can brew a decent IPA or a stout—the real testament of a great brewer is his or her ability to brew an outstanding Kölsch or pilsner. Like the pilsner, the Kölsch is an extremely delicate beer style characterized less for what it is and more for what it isn’t. A great Kölsch should be extremely clean, crisp, and balanced—virtually flawless. The Kölsch has no specialty malt flavors to hide flaws behind. And you can’t cover up any flaws by adding copious amounts of hops.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Even though the colder fermentation levels prevent most ale esters from forming, it is not uncommon to detect a subtle fruitiness in a Köslch’s aroma and flavor. Across the board, a Kölsch should be ultra crisp, clean, and refreshing. No single ingredient should dominate and all flavors should be soft.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("In the glass:")]), _vm._v(" light gold, brilliant, faint head")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("In the nose:")]), _vm._v(" sweet hay, white bread, whisper of pear")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("In the mouth:")]), _vm._v(" unsalted crackers, hints of apple, clean")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("In one word:")]), _vm._v(" Delicate")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Pour it in this:")]), _vm._v(" Kölsch glass or pilsner flute")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Drink instead of:")]), _vm._v(" pinot grigio, vodka")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Pair with:")]), _vm._v(" I’m a big fan of partnering the Kölsch with sushi, shellfish, and other seafood dishes—but it also goes really well with classic German fare.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Brief history lesson:")]), _vm._v(" The Kölsch is kind of an anomaly when you think about it. It was created in Cologne, Germany in the late nineteenth century when pale malts were beginning to make their way into beers. Most German brewers at the time were making pale lagers but, for some reason or another, the crazy kids in Cologne opted to use a local ale yeast strain instead.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As with French wine and Trappist products, the Kölsch is a product with protected geographical indication—which essentially means that only the beers produced in Cologne can bear the name Kölsch. When the style is brewed elsewhere, it’s technically not supposed be called a Kölsch—but many American brewers do it anyways (tsk tsk).")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Try it:")]), _vm._v(" Reissdorf Kölsch, Metropolitan Krankshaft Kölsch, Saranac Kölsch, Alaskan Summer Ale, New Holland Full Circle, Magnolia Kalifornia Kölsch, Calicraft Cali Cöast")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1a756f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch02.vue
// module id = 75
// module chunks = 0